<template>
  <div class="publi w-full h-[300px] flex flex-col items-center justify-center relative overflow-hidden">
    <Sk v-if="loading" w="100%" h="100%" rounded="rounded-none" />
    <TransitionGroup v-else name="fade" class="grow" enter-active-class="animate__animated animate__fadeIn"
                     leave-active-class="animate__animated animate__fadeOut" tag="ul">
      <a v-for="(s, index) in slides" :key="index" v-show="currentIndex == index" :href="s.url" target="_blank"
         rel="noopener noreferrer"
         class="boxSlide h-full w-full flex flex-col justify-end pb-4 px-6 bg-cover bg-center"
         :style="{backgroundImage: `linear-gradient(90deg, rgba(0,0,0,0.5), transparent), url('${s.imagem}')`}">
        <div class="data font-poppins text-white text-wrap overflow-hidden">
          <span class="font-bold text-lg">{{ s.title }}</span><br>
          <span class="font-light text-xs">{{ s.descricao }}</span>
        </div>
      </a>
    </TransitionGroup>
    <div v-if="!loading" class="bolls flex flex-row gap-2 absolute top-4 left-6">
      <div class="boll" v-for="(_, index) in slides.length" :key="index" :class="{active: currentIndex === index}">
        <i class="fa-solid fa-circle cursor-pointer"
           :class="{'text-white': currentIndex === index, 'text-white/60': currentIndex !== index}"
           @click="currentIndex = index"></i></div>
    </div>
  </div>
</template>

<script setup>
import { uploadUrl, BASE, fetchJson } from '@/services/api.js'
import Sk from '@/components/usefulness/Sk.vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'

let slides = ref([])
let loading = ref(true)
let currentIndex = ref(0)

async function getSlides() {
  const data = await fetchJson(BASE + '/records/slides?filter=is_active,eq,1&order=id,asc').catch(() => ({}))
  slides.value = (data.records ?? []).map(s => ({
    title:    s.title,
    descricao: s.description,
    imagem:   uploadUrl(s.image),
    url:      s.url ?? '#',
  }))
  loading.value = false
}

async function startSlide() {
  await getSlides()
  if (slides.value.length > 1) interval = setInterval(next, 7000)
}

function next() {
  if (currentIndex.value < (slides.value.length - 1)) {
    currentIndex.value += 1
  } else {
    currentIndex.value = 0
  }
}

let interval = null

onMounted(startSlide)

onBeforeUnmount(() => {
  if (interval) clearInterval(interval)
})
</script>

<style scoped>

.publi .top .icon {
  background-color: #0D93C6;
  background-position: 5px 5px;
}


.publi .content ul {
  float: left;
  width: 100%;
  height: 400px;
  border-radius: 12px;
}

.publi .content ul li {
  position: absolute;
  top: 0;
  left: 0;
}

.publi .content ul li,
.publi .content ul li > div {
  float: left;
  width: 100%;
  height: 100%;
}

.publi .content ul li .img {
  position: relative;
  float: left;
  width: 100%;
  height: 100%;
  background-position: center;
  background-size: cover;
  border-radius: 12px;
}

.publi .content ul li .data {
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  padding: 10px 10px 18px 10px;
  font-size: 14px;
  line-height: 20px;
  color: #fff;
  background: rgb(0, 0, 0);
  background: linear-gradient(0deg, rgba(0, 0, 0, .7) 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: 0 0 12px 12px;
}

.publi .content ul li .data span {
  float: left;
  width: 100%;
  height: auto;
  text-align: center;
  text-shadow: 0 3px 6px rgba(0, 0, 0, .44);
}

.publi .content ul li .data span:first-of-type {
  font-weight: 500;
}

.publi .content .bolls {
  position: relative;
  top: -2px;
  left: 0;
  width: 100%;
  height: 14px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  color: #fff;
  z-index: 9;
}

.publi .content .bolls .boll {
  opacity: .6;
  margin: 0 3px 0 3px;
}

.publi .content .bolls .boll.active {
  opacity: 1;
}
</style>
